import EverTrue from "app";
import PropTypes from "prop-types";
import NavigationSubItem from "apps/layout/components/navigation-sub-item";
import { useContext } from "react";
import { TasksNotificationContext } from "../hooks/tasks-notification-context.js";
import TaskNotificationBadge from "apps/tasks/task-notification-badge";

const NavigationTaskLink = ({ active_path = "" }) => {
  const { enabled, loaded, tasksDueCount = {} } = useContext(TasksNotificationContext);
  const { owned = 0, assigned = 0 } = tasksDueCount;
  let totalTasksDue = owned + assigned;

  if (!loaded) return null;
  if (enabled) {
    return (
      <>
        <NavigationSubItem
          icon="tasks"
          label="Tasks"
          isActive={!!active_path.match(new RegExp(`tasks.*`))}
          onClick={() => {
            EverTrue.track.set("tasks", { type: "navigate" });
            EverTrue.Navigator("/tasks", true);
          }}
          iconKit="gt2"
        >
          <TaskNotificationBadge count={totalTasksDue} />
        </NavigationSubItem>
      </>
    );
  } else {
    return null;
  }
};

NavigationTaskLink.propTypes = {
  active_path: PropTypes.string,
};

export default NavigationTaskLink;
